<div [ngClass] ="{'shake': shakeIt, 'dialog-class': true}" class="login-wrapper centered"  [formGroup]="loginForm" fxLayout="col" fxLayoutAlign="center center">

  <mat-card class="box">
    <mat-card-header>
      <mat-card-title>{{ 'COMMON.LOG_IN' | translate }}</mat-card-title>
    </mat-card-header>

    <form class="example-form" [formGroup]="loginForm">
      <mat-card-content>
        <mat-form-field class="example-full-width">
          <mat-label>{{ 'COMMON.EMAIL_OR_USER' | translate }}</mat-label>
          <input matInput formControlName="username"  required>
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>{{ 'COMMON.PASSWORD' | translate }}</mat-label>
          <input matInput type="password" formControlName="password" required>
        </mat-form-field>
      </mat-card-content>
      <button mat-stroked-button color="accent" type="submit" class="btn-block" (click)="onSubmit()">{{ 'COMMON.LOG_IN' | translate }}</button>
      <div *ngIf="loginFailed" class="mt-2" style="color: #f44336; text-align: center;">
        <span>E-mail e / ou palavra-passe incorretos</span>
      </div>
      <br>
      <br>
      <div class="mt-2" style="text-align: center;">
        <button mat-button (click)="openDialog()">{{ 'COMMON.INFO' | translate }}</button>
      </div>
    </form>
  </mat-card>

</div>

